<template>
    <template v-for="(subFolder, index) in folderData.arSubFolderInfo" v-bind:key="index">
        <template v-if="(true === filterNotInstallApp && 0 != subFolder.appIDInFolder.filter(x=> false == x.isInstalled).length) || (false === filterNotInstallApp && 0 != subFolder.appIDInFolder.length)">
            <template v-if="0 == index">
                <div style="height: 12px;"></div>
            </template>
            <template v-else>
                <!-- 二つ目以降はセパレータを入れる -->
                <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP"></div>
                <div style="height: 12px;"></div>
            </template>
            <div class="scv-folder-box" @click="onBtnFolderClick(subFolder.catalogFolderID)">
                <div class="d-flex flex-row" style="width: 100%">
                    <div class="svg-container">
                        <img :src="getImageSrc(subFolder.catalogFolderDesign)" alt="" class="scv-folder-icon" style="position: absolute; top: 0; left: 0;">
                        <img :src="getOverlayImageSrc(subFolder.catalogFolderDesign)" alt="" class="overlay" style="height: 56px; min-width: 56px;">
                    </div>
                    <div class="scv-folder-info-box flex-grow-1" style="justify-content: flex-start; overflow: hidden;">
                        <div class="scv-folder-name-text scv-text-default-color-main-FRONTENDEX-MOBILE-APP ellipsis">{{subFolder.catalogFolderName}}</div>
                        <template v-if="filterNotInstallApp">
                            <div class="scv-app-count-text scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">アプリ数 {{subFolder.appIDInFolder.filter(x=> false == x.isInstalled).length}}</div>
                        </template>
                        <template v-else>
                            <div class="scv-app-count-text scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">アプリ数 {{subFolder.appIDInFolder.length}}</div>
                        </template>
                    </div>
                    <div class="ms-auto d-flex align-items-center">
                        <i class="icon-arrow1right"></i>
                    </div>
                </div>
            </div>
            <div style="height: 12px;"></div>
        </template>
    </template>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { FolderInfo, FolderSetting, FolderData } from '@/models/AppCatalog/AppInfo';
    import folderBaseBlue from "@/assets/img/PicFolderBaseBl.png";
    import folderBaseYellow from "@/assets/img/PicFolderBaseYe.png";
    import folderBaseRed from "@/assets/img/PicFolderBaseRe.png";
    import folderBaseGreen from "@/assets/img/PicFolderBaseGr.png"
    import folderIconCircle from "@/assets/img/PicFolderIcoCircle.png";
    import folderIconTriangel from "@/assets/img/PicFolderIcoTriangle.png";
    import folderIconSquare from "@/assets/img/PicFolderIcoSquare.png";
    import folderIconStar from "@/assets/img/PicFolderIcoStar.png";

    @Options({
        props: {
            folderData: { type: FolderData, required: true },
            filterNotInstallApp: { type: Boolean, required: true },
        },
        emits: [
            /**
             * @brief	フォルダクリック
             * @param	FolderInfo: 押下対象
             */
            "onFolderClick"
        ]
    })

    export default class FolderList extends Vue {
        private folderData!: Array<FolderData>;   // フォルダ情報
        private filterNotInstallApp!: boolean;            // 未インストールのみ表示絞り込みフラグ

        /**
         * フォルダクリック
         */
        private onBtnFolderClick(catalogFolderID: number): void {
            this.$emit("onFolderClick", catalogFolderID);
        }

        /**
         * フォルダ画像取得
         */
        public getImageSrc(designNumber: number): string {
            const images = [
                folderBaseBlue,
                folderBaseBlue,
                folderBaseBlue,
                folderBaseBlue,
                folderBaseBlue,
                folderBaseBlue,
                folderBaseYellow,
                folderBaseYellow,
                folderBaseYellow,
                folderBaseYellow,
                folderBaseYellow,
                folderBaseRed,
                folderBaseRed,
                folderBaseRed,
                folderBaseRed,
                folderBaseRed,
                folderBaseGreen,
                folderBaseGreen,
                folderBaseGreen,
                folderBaseGreen,
                folderBaseGreen,
            ];
            return images[designNumber] || folderBaseBlue;
        }

        /**
         * フォルダ重ね画像取得
         */
        public getOverlayImageSrc(designNumber: number): string {
            const images = [
                folderBaseBlue,
                folderBaseBlue, 
                folderIconCircle,
                folderIconTriangel,
                folderIconSquare,
                folderIconStar,
                folderBaseYellow,
                folderIconCircle,
                folderIconTriangel,
                folderIconSquare,
                folderIconStar,
                folderBaseRed,
                folderIconCircle,
                folderIconTriangel,
                folderIconSquare,
                folderIconStar,
                folderBaseGreen,
                folderIconCircle,
                folderIconTriangel,
                folderIconSquare,
                folderIconStar,
            ];
            return images[designNumber] || '';
        }
    }
</script>

<style scoped>
    /* フォルダ情報 */
    .scv-folder-box {
        min-height: 56px; /* 上下マージン(12px, 12px)と合わせて80px*/
        display: flex;
        flex-direction: row;
    }

    /* フォルダアイコン */
    .scv-folder-icon {
        height: 56px;
        min-width: 56px;
        position: absolute;
        top: 0;
        left: 0;
    }

    /* フォルダ情報欄 */
    .scv-folder-info-box {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
    }

    /* フォルダ名 */
    .scv-folder-name-text {
        font-size: 14px;
        margin-top: 12px;
        /* アプリ数との間 */
        line-height: 1.2;
        margin-bottom: 8px;
    }

    /* アプリ数 */
    .scv-app-count-text {
        font-size: 11px;
        line-height: 1.2;
    }

    /* フォルダボタンのエリア */
    .scv-folder-btn-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 16px;
        min-width: max-content; /* ボタンサイズよりは小さくならないように */
    }

    /* フォルダボタンサイズ */
    .scv-folder-btn-size {
        min-width: 96px;
        height: 48px;
    }

    .svg-container {
        position: relative;
        height: 100%;
    }

    .svg-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .overlay {
        top: 20px; /* 重ねる位置を調整 */
        left: 20px; /* 重ねる位置を調整 */
        opacity: 0.5; /* 重ねるSVGの透明度を調整 */
    }

    .ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

</style>